import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../contexts/ToastContext";
import Button from "../components/Button";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";
import FloatingInput from "../components/FloatingInput";
import Icon from "../lib/icon";
import api from "../api";
import "./scss/seller-settings.scss";
import ManagerFooter from "../components/ManagerFooter";

const MIN_PASSWORD_LENGTH = 6;

export default function SellerSettingsPage() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!password || !repeatPassword) {
      showToast("Заполните все поля");
      return;
    }

    if (password.length < MIN_PASSWORD_LENGTH) {
      showToast(`Пароль должен быть не менее ${MIN_PASSWORD_LENGTH} символов`);
      return;
    }

    if (password !== repeatPassword) {
      showToast("Пароли не совпадают");
      return;
    }

    try {
      setLoading(true);

      await api.put("/api/seller/profile/password", {
        newPassword: password
      });

      showToast("Пароль изменён", "info");
      setPassword("");
      setRepeatPassword("");
    } catch {
      showToast("Ошибка смены пароля");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="seller-settings">

      <BackButton />

      <Breadcrumbs
        items={[
          { label: "Главная", path: "/seller/dashboard" },
          { label: "Настройки" }
        ]}
      />

      <h2>Смена пароля</h2>

      <button
        className="seller-settings__support"
        onClick={() => window.open("https://t.me/your_support_bot")}
      >
        <Icon name="message" width={20} height={20} />
        Написать в техподдержку
      </button>

      <div className="seller-settings__form">

        <FloatingInput
          label="Новый пароль"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <FloatingInput
          label="Повторите новый пароль"
          type="password"
          value={repeatPassword}
          onChange={(e) => setRepeatPassword(e.target.value)}
        />

      </div>

      <Button
        className="btn-primary large"
        onClick={handleSubmit}
        load={loading}
      >
        Изменить пароль
      </Button>

    </div>
    <ManagerFooter /></>
  );
}
